import React from 'react';
import styled from 'styled-components';

import { abbreviateNumber } from "js-abbreviation-number";

const Container = styled.div`
    background-color: ${props => props.$backgroundColor};
    padding: 1.125rem;
    border-radius: 1rem;
    width: 100%;
    min-width: 11.25rem;
`;

const Icon = styled.div`
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 2.5rem;
    color: #FFFFFF;
    font-size: 1.25rem;
    background-color: ${props => props.$iconBackground};
`;

const Title = styled.div`
    color: #151D48;
    font-size: 1.5rem;
    font-weight: 700;
    margin: 1rem 0 0.5rem 0;
`;

const Label = styled.div`
    color: #425166;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5rem;
    margin-bottom: 0.5rem;
    text-transform: capitalize;
`;

const SubLabel = styled.div`
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1rem;
    color: #44079ED;
`;

const DashboardCard = ({ backgroundColor, iconBackground, icon, value, label, subLabel }) => {
    return ( 
        <Container $backgroundColor={backgroundColor}>
            <Icon $iconBackground={iconBackground} className='d-flex justify-content-center align-items-center'>
                <i className={"mdi mdi-" + icon}></i>
            </Icon>

            <Title>
                {abbreviateNumber(value)}
            </Title>

            <Label>
                {label}
            </Label>
           
            <SubLabel>
                {subLabel}
            </SubLabel>
        </Container>
     );
};
 
export default DashboardCard;